<style>
.popover{
  max-width: 500px!important;
}
</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import datatableMixin from '@/helpers/mixins/datatableMixin'

export default {
    page: {
        title: "Müşteri Memnuniyeti",
    },
    mixins: [ datatableMixin ],
    components: {
        Layout,
        PageHeader
    },
    data() {
        return {
            title: "Müşteri Memnuniyeti",
            items: [
                {
                    text: "ANASAYFA",
                    href: "/",
                },
                {
                    text: "MÜŞTERİ MEMNUNİYETİ",
                    active: true,
                },
            ],
            tableData: {
            detail: false,
            excel: true,
                searchable:{
                    visible:true,
                    placeholder:"İsim Soyisim Ara"
                }
            },
            // default search params: current month/year
            searchParams: (function(){ const d = new Date(); return { month: d.getMonth()+1, year: d.getFullYear() } })(),
            exportName: 'memnuniyet',
            endpoint: '/reports/survey',
            modelOpen:0,
            subsId:{},
            stats:{}
        };
    },
    mounted(){
        this.getStats();
    },
  methods: {
    async loadPage() {
        this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true

        const payload = Object.assign({ params: this.params, sort:this.sort, search_query: this.searchQuery }, this.searchParams || {});
        const response = await  this.$http.post(this.endpoint, payload);
        if (this.params.page === 1) {
            this.tableData.data = response.data.data;
        } else {
            this.tableData.data = [...this.tableData.data, ...response.data.data];
        }

        this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
        this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false

        this.lastUpdated = new Date().toLocaleTimeString();
    },

    async getStats(){
        const response = await this.$http.post('reports/survey-stats');
        this.stats = response.data;
    },

        // change month using YYYY-MM value from input[type=month]
        applyMonth(monthValue){
            if(!monthValue) return;
            const parts = monthValue.split('-');
            if(parts.length!==2) return;
            this.searchParams.month = Number(parts[1]);
            this.searchParams.year = Number(parts[0]);
            // reload data
            this.params.page = 1;
            this.loadPage();
        },

        downloadExcel(){
            // ensure exportName set
            this.exportName = 'memnuniyet_' + (this.searchParams.year||'') + ('0'+(this.searchParams.month||'')).slice(-2);
            // datatableMixin expects searchParams as body and will append ?excel=true
            this.excelExport();
        },

    popoverContent(histories) {
      const listItems = histories.map(history => {
        return `
          <li>${history.description}</li>
        `;
      }).join('');

      return `<ul>${listItems}</ul>`;
    },


   }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />

    <div class="row text-center g-2">
        <div class="col">
            <div class="card p-1" style="height: 80px;
                background: linear-gradient(135deg, #ffffff, #f8f9fa);
                border-bottom: 4px solid #0d6efd;">
            <div class="card-body d-flex flex-column justify-content-center">
                <h6 class="mb-0" style="font-size: 0.8rem;">Toplam</h6>
                <p class="mb-0" style="font-size: 1rem;">{{ stats.total_services }}</p>
            </div>
            </div>
        </div>

        <div class="col">
            <div class="card p-1" style="height: 80px;
                background: linear-gradient(135deg, #ffffff, #f8f9fa);
                border-bottom: 4px solid #6c757d;">
            <div class="card-body d-flex flex-column justify-content-center">
                <h6 class="mb-0" style="font-size: 0.8rem;">Katılmayan</h6>
                <p class="mb-0" style="font-size: 1rem;">{{ stats.no_survey }}</p>
            </div>
            </div>
        </div>

        <div class="col">
            <div class="card p-1" style="height: 80px;
                background: linear-gradient(135deg, #ffffff, #f8f9fa);
                border-bottom: 4px solid #ffc107;">
            <div class="card-body d-flex flex-column justify-content-center">
                <h6 class="mb-0" style="font-size: 0.8rem;">Yapılmadı</h6>
                <p class="mb-0" style="font-size: 1rem;">{{ stats.yapilmadi }}</p>
            </div>
            </div>
        </div>

        <div class="col">
            <div class="card p-1" style="height: 80px;
                background: linear-gradient(135deg, #ffffff, #f8f9fa);
                border-bottom: 4px solid #dc3545;">
            <div class="card-body d-flex flex-column justify-content-center">
                <h6 class="mb-0" style="font-size: 0.8rem;">Ulaşılamadı</h6>
                <p class="mb-0" style="font-size: 1rem;">{{ stats.ulasilamadi }}</p>
            </div>
            </div>
        </div>

        <div class="col">
            <div class="card p-1" style="height: 80px;
                background: linear-gradient(135deg, #ffffff, #f8f9fa);
                border-bottom: 4px solid #212529;">
            <div class="card-body d-flex flex-column justify-content-center">
                <h6 class="mb-0" style="font-size: 0.8rem;">Reddetti</h6>
                <p class="mb-0" style="font-size: 1rem;">{{ stats.reddetti }}</p>
            </div>
            </div>
        </div>

        <div class="col">
            <div class="card p-1" style="height: 80px;
                background: linear-gradient(135deg, #ffffff, #f8f9fa);
                border-bottom: 4px solid #198754;">
            <div class="card-body d-flex flex-column justify-content-center">
                <h6 class="mb-0" style="font-size: 0.8rem;">Kabul Etti</h6>
                <p class="mb-0" style="font-size: 1rem;">{{ stats.kabuletti }}</p>
            </div>
            </div>
        </div>
    </div>



    <div class="row mt-2">
      <div class="col-12">
        <div class="card mb-0">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="d-flex align-items-center">
                        <label class="me-2 mb-0">Ay:</label>
                        <input type="month" class="form-control form-control-sm me-2" :value="(searchParams.year? (String(searchParams.year)+'-'+('0'+searchParams.month).slice(-2)) : '')" @change="e=>applyMonth(e.target.value)" />
                        <button class="btn btn-outline-secondary btn-sm" @click="applyMonth((new Date()).toISOString().slice(0,7))">Bu Ay</button>
                    </div>
                    <div>
                        <button class="btn btn-success btn-sm" @click="downloadExcel"><i class="bx bx-download"></i> Excel</button>
                    </div>
                </div>
                <div class="table-responsive" style="min-height: 300px;">
                    <table class="table table-hover">
                        <thead class="table-head" >
                            <tr>
                                <th style="width:2%"></th>
                                <th>Soru</th>
                                <th>Evet</th>
                                <th>Hayır</th>
                                <th>1</th>
                                <th>2</th>
                                <th>3</th>
                                <th>4</th>
                                <th>5</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rowIndex) in tableData.data" :key="rowIndex" >
                                <th>{{ rowIndex+=1 }}</th>
                                <th>{{ row.content_tr }}</th>
                                <td>{{ row.type == 'scored' ? '-' : row.evet }}</td>
                                <td>{{ row.type == 'scored' ? '-' : row.hayir }}</td>
                                <td>{{ row.type == 'optional' ? '-' : row.count_1 }}</td>
                                <td>{{ row.type == 'optional' ? '-' : row.count_2 }}</td>
                                <td>{{ row.type == 'optional' ? '-' : row.count_3 }}</td>
                                <td>{{ row.type == 'optional' ? '-' : row.count_4 }}</td>
                                <td>{{ row.type == 'optional' ? '-' : row.count_5 }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      </div>
    </div>
  </Layout>
</template>